export const lodgeMeta = {
  name: 'Hartwood Lodge',
  tagline: 'Highland Estate · Est. 1924',
  period: 'October 2026'
};

export const kpis = [
  { label: 'Occupancy Rate', value: '82%', delta: '+6.4%', trend: 'up', hint: 'vs last month' },
  { label: 'Revenue (MTD)', value: 'R 412,580', delta: '+12.1%', trend: 'up', hint: 'ADR R 1,840' },
  {
    label: 'Guest Satisfaction',
    value: '4.8 / 5',
    delta: '+0.2',
    trend: 'up',
    hint: '127 reviews'
  },
  {
    label: 'Active Bookings',
    value: '38',
    delta: '9 arrivals today',
    trend: 'neutral',
    hint: '12 departures'
  }
];

export const occupancyTrend = [
  { day: 'Mon', occupancy: 64, adr: 1620 },
  { day: 'Tue', occupancy: 71, adr: 1700 },
  { day: 'Wed', occupancy: 78, adr: 1755 },
  { day: 'Thu', occupancy: 84, adr: 1820 },
  { day: 'Fri', occupancy: 96, adr: 2100 },
  { day: 'Sat', occupancy: 98, adr: 2240 },
  { day: 'Sun', occupancy: 88, adr: 1980 }
];

export const revenueBreakdown = [
  { name: 'Rooms', value: 248000, color: 'hsl(var(--primary))' },
  { name: 'Restaurant', value: 86500, color: 'hsl(var(--accent))' },
  { name: 'Activities', value: 42300, color: 'hsl(var(--moss))' },
  { name: 'Farm Shop', value: 35780, color: 'hsl(var(--clay))' }
];

export const monthlyFinance = [
  { m: 'May', revenue: 318, expenses: 198 },
  { m: 'Jun', revenue: 286, expenses: 192 },
  { m: 'Jul', revenue: 352, expenses: 210 },
  { m: 'Aug', revenue: 398, expenses: 225 },
  { m: 'Sep', revenue: 376, expenses: 218 },
  { m: 'Oct', revenue: 412, expenses: 232 }
];

export const bookings = [
  {
    id: 'BK-2841',
    guest: 'Eleanor Whitfield',
    room: 'Stag Suite',
    arrive: 'Today',
    nights: 4,
    status: 'Arriving',
    party: 2
  },
  {
    id: 'BK-2842',
    guest: 'Marcus & Lila Chen',
    room: 'Pinewood Cabin 3',
    arrive: 'Today',
    nights: 7,
    status: 'Arriving',
    party: 4
  },
  {
    id: 'BK-2839',
    guest: 'Dr. Patel Family',
    room: 'Heritage Wing 12',
    arrive: 'Yesterday',
    nights: 3,
    status: 'In-house',
    party: 5
  },
  {
    id: 'BK-2837',
    guest: 'Aiden Brooks',
    room: 'Loft Studio',
    arrive: 'Oct 2',
    nights: 5,
    status: 'In-house',
    party: 1
  },
  {
    id: 'BK-2845',
    guest: 'Voss Wedding Party',
    room: 'Whole Estate',
    arrive: 'Oct 14',
    nights: 3,
    status: 'Confirmed',
    party: 42
  },
  {
    id: 'BK-2846',
    guest: 'T. Adebayo',
    room: 'Stag Suite',
    arrive: 'Oct 18',
    nights: 2,
    status: 'Confirmed',
    party: 2
  }
];

export const guests = [
  { name: 'Eleanor Whitfield', country: 'UK', visits: 6, tier: 'Platinum', spend: 'R 184k' },
  { name: 'Marcus Chen', country: 'Singapore', visits: 2, tier: 'Gold', spend: 'R 62k' },
  { name: 'Patel Family', country: 'India', visits: 4, tier: 'Gold', spend: 'R 98k' },
  { name: 'Aiden Brooks', country: 'South Africa', visits: 11, tier: 'Platinum', spend: 'R 220k' },
  { name: 'Sofia Marchetti', country: 'Italy', visits: 1, tier: 'Silver', spend: 'R 18k' }
];

export const staff = [
  { role: 'Front Office', on: 4, scheduled: 5, status: 'Covered' },
  { role: 'Housekeeping', on: 7, scheduled: 8, status: 'Short' },
  { role: 'Kitchen', on: 6, scheduled: 6, status: 'Covered' },
  { role: 'Grounds & Farm', on: 5, scheduled: 5, status: 'Covered' },
  { role: 'Activities', on: 2, scheduled: 3, status: 'Short' }
];

export const operations = [
  {
    task: 'Deep clean Heritage Wing 4-8',
    owner: 'Housekeeping',
    due: 'Today 14:00',
    priority: 'High'
  },
  {
    task: 'Boiler service — North Block',
    owner: 'Maintenance',
    due: 'Tomorrow',
    priority: 'Medium'
  },
  { task: 'Restock minibars (12 rooms)', owner: 'F&B', due: 'Today 16:00', priority: 'Medium' },
  { task: 'Inspect riding trail bridge', owner: 'Grounds', due: 'Oct 6', priority: 'Low' }
];

export const farming = [
  {
    area: 'Vegetable Garden',
    yield: '184 kg',
    change: '+22%',
    note: 'Tomatoes, kale, beets — supplying kitchen'
  },
  { area: 'Orchard', yield: '96 kg', change: '+8%', note: 'Apples & pears, pressing on Friday' },
  {
    area: 'Dairy (Jersey herd)',
    yield: '412 L',
    change: '+3%',
    note: '12 cows in milk, butter for restaurant'
  },
  { area: 'Free-range Eggs', yield: '1,820', change: '+11%', note: 'Surplus sold via farm shop' },
  { area: 'Honey (12 hives)', yield: '38 kg', change: '—', note: 'Late harvest planned for Oct 20' }
];

export const farmingTrend = [
  { w: 'W1', veg: 38, dairy: 96, eggs: 410 },
  { w: 'W2', veg: 44, dairy: 102, eggs: 442 },
  { w: 'W3', veg: 49, dairy: 108, eggs: 468 },
  { w: 'W4', veg: 53, dairy: 106, eggs: 500 }
];

export const departments = [
  { refId: 1, departmentName: 'Hospitality' },
  { refId: 2, departmentName: 'Repairs and Maint' },
  { refId: 3, departmentName: 'Kitchen' },
  { refId: 4, departmentName: 'Stores Hospitality' },
  { refId: 5, departmentName: 'Stores Admin' },
  { refId: 6, departmentName: 'Admin' },
  { refId: 7, departmentName: 'Building' }
];
